import _ from 'underscore';

angular.module('am4').controller('editAddressCtrl', function($scope, $rootScope, countries, geoService, errorService, orgFacService) {
    $scope.editAddress = _.clone($scope.address);

    $scope.submit = function() {
        $scope.isSaving = true;

        const body = {
            address: {
                street1: $scope.editAddress.street1,
                street2: $scope.editAddress.street2 || '',
                city: $scope.editAddress.city,
                postal_code: $scope.editAddress.postal_code,
                state_id: ($scope.selectedState && $scope.selectedState.id) || 0,
                country_id: $scope.selectedCountry.id
            }
        };

        return orgFacService.updateFacility($scope.facility_id, body)
        .finally(function() {
            $scope.isSaving = false;
            $scope.closeThisDialog();
        })
        .then(function() {
            $rootScope.$broadcast('facilityAddress:update');
        })
        .catch(function(e) {
            errorService.addError('CONTACT_UPDATE_ERROR', e);
        });
    };

    $scope.countries = countries;

    for (let i = 0; i < $scope.countries.length; i++) {
        if ($scope.countries[i].iso === $scope.editAddress.countryISO) {
            $scope.selectedCountry = $scope.countries[i];
        }
    }

    $scope.$watch('selectedState', function(state) {
        if (state) {
            $scope.editAddress.state_iso = state.iso;
        }
    });

    $scope.$watch('selectedCountry', function(country) {
        if (angular.isDefined(country)) {
            $scope.editAddress.countryISO = country.iso;

            $scope.loadingCountries = true;

            geoService.getStates(country.id)
            .then(function(states) {
                $scope.loadingCountries = false;
                $scope.states = states;

                if ($scope.editAddress.stateISO) {
                    for (var i = 0; i < $scope.states.length; i++) {
                        if ($scope.states[i].iso === $scope.editAddress.stateISO) {
                            $scope.selectedState = $scope.states[i];
                        }
                    }
                }
            })
            .catch(function(e) {
                errorService.addError('GET_STATES_ERROR', e);
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/app/controllers/editAddressCtrl.js